import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Password_request } from '../models/password_request';
import { AppSettings } from '../app.settings';

export interface SmsAccount { masked_username: string; user_id: string; }
export interface SmsVerifyResponse { token?: string; selection_token?: string; accounts?: SmsAccount[]; }

@Injectable({
  providedIn: 'root'
})
export class LostPasswordService {

  constructor(private http: HttpClient) { }

  get(token: string): Promise<Password_request> {
    return this.getWithRest("make_change/token/" + token);
  }

  private getWithRest(rest_url: string): Promise<Password_request> {
    return new Promise((resolve, reject) => {
      return this.http.get(AppSettings.API_ENDPOINT + 'lost_password/' + rest_url).subscribe((response: any) => {
        if (response.type == 'password_request' && response.data) {
          resolve(response.data);
        } else {
          reject(response);
        }

      },
        error_response => {
          if (error_response instanceof HttpErrorResponse) {
            reject(error_response.error);
          }
          reject(error_response);
        });
    });
  }

  submitRequest(username: string, email: string): Promise<any> {

    let post_data = {
      username: username, email: email
    };

    return new Promise((resolve, reject) => {

      return this.http.post(AppSettings.API_ENDPOINT + 'lost_password/generate_password_change_request',
        post_data, AppSettings.DEFAULT_HTTP_OPTIONS).subscribe((response: any) => {
          if (response.data && response.type == 'password_change_request_response') {
            resolve(response.data);
          } else {
            reject(response);
          }

        }, error => {
          if (error instanceof HttpErrorResponse) {
            reject(error.error);
          } else {
            reject(error);
          }
        });
    });

  }

  submitSmsRequest(phone: string): Promise<any> {
    return new Promise((resolve, reject) => {
      return this.http.post(AppSettings.API_ENDPOINT + 'lost_password/sms_request',
        { phone }, AppSettings.DEFAULT_HTTP_OPTIONS).subscribe((response: any) => {
          resolve(response);
        }, error => {
          if (error instanceof HttpErrorResponse) {
            reject(error.error);
          } else {
            reject(error);
          }
        });
    });
  }

  // PHP API responses are wrapped by Format::to_json as { type, data } —
  // unwrap data here so callers see the bare payload.
  verifySmsOtp(phone: string, otp: string): Promise<SmsVerifyResponse> {
    return new Promise((resolve, reject) => {
      return this.http.post(AppSettings.API_ENDPOINT + 'lost_password/sms_verify',
        { phone, otp }, AppSettings.DEFAULT_HTTP_OPTIONS).subscribe((response: any) => {
          if (response && response.type === 'lost_password_sms_verify_response' && response.data) {
            resolve(response.data);
          } else {
            reject(response);
          }
        }, error => {
          if (error instanceof HttpErrorResponse) {
            reject(error.error);
          } else {
            reject(error);
          }
        });
    });
  }

  confirmSmsAccount(user_id: string, selection_token: string): Promise<{ token: string }> {
    return new Promise((resolve, reject) => {
      return this.http.post(AppSettings.API_ENDPOINT + 'lost_password/sms_confirm_account',
        { user_id, selection_token }, AppSettings.DEFAULT_HTTP_OPTIONS).subscribe((response: any) => {
          if (response && response.type === 'lost_password_sms_confirm_account_response' && response.data) {
            resolve(response.data);
          } else {
            reject(response);
          }
        }, error => {
          if (error instanceof HttpErrorResponse) {
            reject(error.error);
          } else {
            reject(error);
          }
        });
    });
  }

  submitNewPassword(token: string, password: string, repeat_password: string): Promise<any> {

    let post_data = {
      token: token, password: password, repeat_password: repeat_password
    };

    return new Promise((resolve, reject) => {

      return this.http.post(AppSettings.API_ENDPOINT + 'lost_password/make_change',
        post_data, AppSettings.DEFAULT_HTTP_OPTIONS).subscribe((response: any) => {
          if (response.data && response.type == 'password_reset_response') {
            resolve(response.data);
          } else {
            reject(response);
          }

        }, error => {
          if (error instanceof HttpErrorResponse) {
            reject(error.error);
          } else {
            reject(error);
          }
        });
    });


  }

}
